import { useImpersonation } from '@/contexts/ImpersonationContext';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Eye, X } from 'lucide-react';

export const ImpersonationBanner = () => {
  const { impersonatedUser, stopImpersonation, isImpersonating } = useImpersonation();

  if (!isImpersonating || !impersonatedUser) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-50 bg-orange-500 text-white py-2 px-4 shadow-lg">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Eye className="h-5 w-5" />
          <span className="font-medium">View-Only Mode:</span>
          <div className="flex items-center gap-2">
            <Avatar className="h-6 w-6 border border-white/30">
              <AvatarImage src={impersonatedUser.avatar_url || ''} />
              <AvatarFallback className="text-xs bg-orange-600">
                {impersonatedUser.full_name?.charAt(0) || impersonatedUser.username?.charAt(0) || 'U'}
              </AvatarFallback>
            </Avatar>
            <span>
              Viewing as <strong>{impersonatedUser.full_name || impersonatedUser.username || 'Unknown User'}</strong>
            </span>
          </div>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={stopImpersonation}
          className="text-white hover:bg-orange-600 hover:text-white"
        >
          <X className="h-4 w-4 mr-1" />
          Exit View Mode
        </Button>
      </div>
    </div>
  );
};
